import {sendMessage} from './input-field';
import {addMessage, clickOnButton} from './chat-body';
import {initProtocol, initApp} from './chat-root';
import {clickDebuggerButton, clickFullButton, clickCloseButton} from './chat-header';

export {
  sendMessage,
  addMessage,
  initProtocol,
  initApp,
  clickDebuggerButton,
  clickFullButton,
  clickCloseButton,
  clickOnButton
};



// WEBPACK FOOTER //
// ./src/actions/index.js